import { FetchStatus, Property, PropertyType } from "../../../../../base/types";
import { useEffect, useState } from "react";

import { IAsyncBoundProperties } from "../../../../../base/hooks";
import { ILookupProps } from "./ILookupProps";

export const LookupProperties = [
    { id: Property.Label, name: 'Label', type: PropertyType.String },
    { id: Property.InitValue, name: 'Value', type: PropertyType.String },
    { id: Property.TableLookup, name: 'Table Lookup', type: PropertyType.TableLookup },
    { id: Property.Required, name: 'Required', type: PropertyType.Boolean },
    { id: Property.Readonly, name: 'Readonly', type: PropertyType.Boolean },
    { id: Property.Disabled, name: 'Disabled', type: PropertyType.Boolean },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
    { id: Property.Placeholder, name: 'Tooltip', type: PropertyType.String },
]

export const useLookupProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<ILookupProps>()

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const attributes: ILookupProps = {
            label: bindings.getValue(Property.Label) || '',
            value: bindings.getValue(Property.InitValue) || '',
            tableLookup: bindings.getValue(Property.TableLookup),
            required: bindings.getValue(Property.Required) || false,
            readOnly: bindings.getValue(Property.Readonly) || false,
            disabled: bindings.getValue(Property.Disabled) || false,
            title: bindings.getValue(Property.Tooltip) || '',
            placeholder: bindings.getValue(Property.Placeholder) || '',
        };

        setProperties(attributes)
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties }
}
